import type { SanityPageBuilderIntroHeadlineSection, SanityPageBuilderSection } from "@ouster/shared";
import { IntroHeadlineBlockView } from "~/features/blocks/inventory/intro-headline";
import { toCraftLinkArray } from "~/features/sanity/link";
import { SanityRichText } from "~/features/sanity/rich-text";
import { hasRenderableSanityMedia, SanityMediaFigure } from "./media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderIntroHeadlineSection;
  };
};
export function SanityIntroHeadlineSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const text = sectionContent.text?.length ? <SanityRichText value={sectionContent.text} /> : undefined;
  const hasMedia = hasRenderableSanityMedia(sectionContent.media);
  return <IntroHeadlineBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} hasSolidBackground={sectionContent.hasSolidBackground} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} link={toCraftLinkArray(sectionContent.link)}
  // Natural aspect ratio on every breakpoint: the design shows the full image, uncropped.
  mediaDesktop={hasMedia ? <SanityMediaFigure media={sectionContent.media} sizes="lg:50vw" /> : undefined} mediaMobile={hasMedia ? <SanityMediaFigure media={sectionContent.media} sizes="lg:50vw" /> : undefined} mediaPosition={sectionContent.mediaPosition} mode={sectionSettings?.mode || "light"} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} text={text} theme={sectionSettings?.theme || "white"} />;
}